import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SideNav {
    selectedHeader?: string; 
    selectedSubHeader?: string; 
}

const initialState: SideNav = {
    selectedHeader: '', 
    selectedSubHeader: '',
};

export const sideNavSlice = createSlice({
    name: 'sideNavState',
    initialState,
    reducers: {
        setSideNav: (state, action: PayloadAction<SideNav>) => { 
            state.selectedHeader = action.payload.selectedHeader;
            state.selectedSubHeader = action.payload.selectedSubHeader;
        },
    },
});

export const { setSideNav } = sideNavSlice.actions;
export default sideNavSlice.reducer;
